import React from "react";
import styled from 'styled-components'
import PageWrapper from "./pageWrapper";
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
import parse from 'html-react-parser';
import htmlDecode from '../utils/htmlDecode'
import Grid from 'styled-components-grid';
import isMobile from '../utils/ismobile'
import ModalImage from "react-modal-image";


const ContentWrapper = styled.div`
    width: 100%;
    background-color: #fff;
    min-height: 200px;
    padding: 20px;
`

const ContentBlock = styled.div`
    padding: 5px 10px;
`

const GalleryBlock = styled.div`
    padding: 5px 10px;
    > div{
        display: inline-block;
        margin-right: 5px;
        margin-bottom: 5px;
    }
    .thumbnail{
        width: 100px;
    }
`


const SectionWrapper = styled.div`
    margin-bottom: 30px;
    padding-bottom: 15px;
    border-bottom: 1px solid; 
    border-bottom-color: ${props => props.theme.grey1};
`

function Content(props) {
    let sections = props.content.sections;
    let mobile = isMobile();
    return(
        <PageWrapper>
            <ContentWrapper>
            {(sections) ? sections.map((section, key) => {
                return (
                    
                    <SectionWrapper key={key} id={`section${key}`}>
                        <Grid>
                            {(section.fields.content) ? section.fields.content.map((block, key2) => {
                               
                                const contentHtml = htmlDecode(documentToHtmlString(block.fields.content)) || ""
                                const size = (mobile) ? "1/1" :  (block.fields.size || "1/1");
                                const calcSize = parseInt(size.substr(size.length - 1))
                                const images = block.fields.images || ""

                                return (
                                    <Grid.Unit size={1 / calcSize} key={key2}>
                                        {(images) ? 
                                            (<GalleryBlock>
                                                {(images) ? images.map((image, key3) => {
                                                    let thumb = image.fields.thumbnail.fields.file.url;
                                                    let largeImage = image.fields.largeImage.fields.file.url;
                                                    return (<ModalImage
                                                        className="thumbnail"
                                                        small={thumb}
                                                        hideDownload={true}
                                                        large={largeImage}
                                                        key={key3}
                                                    />)
                                                }) : ""}
                                            </GalleryBlock>) : 
                                            (<ContentBlock >{parse(contentHtml)}</ContentBlock>) }
                                    </Grid.Unit>
                                )
                            }) : ""}
                        </Grid>
                    </SectionWrapper>
                   
                )
            }) : ""}
            </ContentWrapper>
        </PageWrapper>
    )
}

export default Content;